import { normalizeToTimezoneList } from '@/lib/scheduling/timezone';

// Comprehensive timezones matching Django backend
export const TIMEZONE_OPTIONS = [
  { value: '', label: 'Not Set' },
  { value: 'UTC', label: 'UTC' },

  // Africa
  { value: 'Africa/Abidjan', label: 'Africa/Abidjan' },
  { value: 'Africa/Cairo', label: 'Africa/Cairo' },
  { value: 'Africa/Casablanca', label: 'Africa/Casablanca' },
  { value: 'Africa/Johannesburg', label: 'Africa/Johannesburg' },
  { value: 'Africa/Lagos', label: 'Africa/Lagos' },
  { value: 'Africa/Nairobi', label: 'Africa/Nairobi' },

  // America - North America
  { value: 'America/Anchorage', label: 'America/Anchorage' },
  { value: 'America/Chicago', label: 'America/Chicago' },
  { value: 'America/Denver', label: 'America/Denver' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles' },
  { value: 'America/New_York', label: 'America/New_York' },
  { value: 'America/Phoenix', label: 'America/Phoenix' },
  { value: 'America/Toronto', label: 'America/Toronto' },
  { value: 'America/Vancouver', label: 'America/Vancouver' },

  // America - Central/South America
  {
    value: 'America/Argentina/Buenos_Aires',
    label: 'America/Argentina/Buenos_Aires',
  },
  { value: 'America/Bogota', label: 'America/Bogota' },
  { value: 'America/Caracas', label: 'America/Caracas' },
  { value: 'America/Lima', label: 'America/Lima' },
  { value: 'America/Mexico_City', label: 'America/Mexico_City' },
  { value: 'America/Santiago', label: 'America/Santiago' },
  { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo' },

  // Asia
  { value: 'Asia/Bangkok', label: 'Asia/Bangkok' },
  { value: 'Asia/Calcutta', label: 'Asia/Calcutta' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai' },
  { value: 'Asia/Hong_Kong', label: 'Asia/Hong_Kong' },
  { value: 'Asia/Jakarta', label: 'Asia/Jakarta' },
  { value: 'Asia/Jerusalem', label: 'Asia/Jerusalem' },
  { value: 'Asia/Karachi', label: 'Asia/Karachi' },
  { value: 'Asia/Manila', label: 'Asia/Manila' },
  { value: 'Asia/Seoul', label: 'Asia/Seoul' },
  { value: 'Asia/Shanghai', label: 'Asia/Shanghai' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore' },
  { value: 'Asia/Tehran', label: 'Asia/Tehran' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo' },

  // Australia/Pacific
  { value: 'Australia/Adelaide', label: 'Australia/Adelaide' },
  { value: 'Australia/Brisbane', label: 'Australia/Brisbane' },
  { value: 'Australia/Melbourne', label: 'Australia/Melbourne' },
  { value: 'Australia/Perth', label: 'Australia/Perth' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney' },
  { value: 'Pacific/Auckland', label: 'Pacific/Auckland' },
  { value: 'Pacific/Fiji', label: 'Pacific/Fiji' },
  { value: 'Pacific/Honolulu', label: 'Pacific/Honolulu' },

  // Europe
  { value: 'Europe/Amsterdam', label: 'Europe/Amsterdam' },
  { value: 'Europe/Berlin', label: 'Europe/Berlin' },
  { value: 'Europe/Brussels', label: 'Europe/Brussels' },
  { value: 'Europe/Copenhagen', label: 'Europe/Copenhagen' },
  { value: 'Europe/Dublin', label: 'Europe/Dublin' },
  { value: 'Europe/Helsinki', label: 'Europe/Helsinki' },
  { value: 'Europe/Istanbul', label: 'Europe/Istanbul' },
  { value: 'Europe/London', label: 'Europe/London' },
  { value: 'Europe/Madrid', label: 'Europe/Madrid' },
  { value: 'Europe/Moscow', label: 'Europe/Moscow' },
  { value: 'Europe/Oslo', label: 'Europe/Oslo' },
  { value: 'Europe/Paris', label: 'Europe/Paris' },
  { value: 'Europe/Rome', label: 'Europe/Rome' },
  { value: 'Europe/Stockholm', label: 'Europe/Stockholm' },
  { value: 'Europe/Vienna', label: 'Europe/Vienna' },
  { value: 'Europe/Warsaw', label: 'Europe/Warsaw' },
  { value: 'Europe/Zurich', label: 'Europe/Zurich' },
];

/**
 * Normalize a detected timezone to match TIMEZONE_OPTIONS.
 * Handles IANA timezone aliases by matching UTC offsets when exact match fails.
 *
 * @param detected - Browser-detected timezone (e.g., 'Asia/Kolkata')
 * @returns Normalized timezone from TIMEZONE_OPTIONS or 'UTC' if no match
 *
 * @example
 * normalizeTimezone('Asia/Kolkata') // Returns 'Asia/Calcutta'
 * normalizeTimezone('Asia/Calcutta') // Returns 'Asia/Calcutta'
 * normalizeTimezone('Invalid/Timezone') // Returns 'UTC'
 */
export function normalizeTimezone(detected: string): string {
  return normalizeToTimezoneList(detected, TIMEZONE_OPTIONS);
}
